export const textsEn = {
  privacyPolicy: 'Privacy Policy',
  termsOfUse: 'Terms of Use',
  mainHeader: `Financial tools: 12C calculator, loan,
   amortization of financing, investments, compound interest`,
};
